import React from "react";


import Dogs from "./Dogs/Dogs";
import NavBar from "./Nav_SearchBar/NavBar.jsx";

export default function Home() {

  

  return (
    <>
      <NavBar/>
       <Dogs /> 
    </>
  );
}
